import { TableNames } from "../../customEnums/TableNames";
import { PageNames } from "../../interfaces/config";
import { Components } from "../../customEnums/tableStoreEnums";
import { TableState } from "../../interfaces/";

export const initialState: TableState = {
    userActive: false,
    tableConfig: {},
    buttonCellHandlers: {},
    internalSearchArray: [],
    pageName: "",
    actionsConfig: [],
    currentCell: "",
    currentDataIndex: "",
    customFilterAnchorEl: null,
    currentRow: null,
    displayNoSearchResults: false,
    selected: [],
    tcns: [],
    componentConfig: {
        [Components.CUSTOM_FILTER]: {
            selectedValue: "",
            handleRadioChange: () => { }
        },
    },
    configService: {
        closedAlert: true,
        searchData: {},
        alertData: {},
        rfpListData: {},
        loadingConfig: false,
        postedConfig: false,
        errorConfig: false
    },
    detailsTable: ['incoming-responses', 'outgoing-transmission', 'status-history', 'adjudication-documents'],
    pagination: {
        [TableNames.TRANSACTION_SUMMARY]: {
            page: 1,
            rowsPerPage: 25,
            order: "desc",
            orderBy: "transactionDate"
        },
        [TableNames.REJECT_CODES]: {
            page: 0,
            rowsPerPage: 5,
            order: "desc",
            orderBy: "rejectIndex"
        },
        [TableNames.RAPBACK_SUMMARY]: {
            page: 1,
            rowsPerPage: 25,
            order: "desc",
            orderBy: "insertDate"
        },
        [TableNames.RB_SUMMARY_AUDIT_HISTORY]: {
            page: 0,
            rowsPerPage: 10,
            order: "desc",
            orderBy: "date"
        },
        [TableNames.RAPBACK_MAINTENANCE]: {
            page: 1,
            rowsPerPage: 25,
            order: "desc",
            orderBy: "subscriptionDate"
        },
        [TableNames.RB_SUB_AUDIT_HISTORY]: {
            page: 0,
            rowsPerPage: 5,
            order: "desc",
            orderBy: "date"
        },
        [TableNames.RAPBACK_VALIDATIONS]: {
            page: 1,
            rowsPerPage: 25,
            order: "asc",
            orderBy: "daysToExpire"
        },
        [TableNames.RAPBACK_PRENOTIFICATIONS]: {
            page: 1,
            rowsPerPage: 25,
            order: "desc",
            orderBy: "subscriptionDate"
        },
        [TableNames.AGENCY_MANAGEMENT]: {
            page: 1,
            rowsPerPage: 25,
            order: "desc",
            orderBy: "agencyName"
        },
        [TableNames.USER_MANAGEMENT]: {
            page: 0,
            rowsPerPage: 25,
            order: "asc",
            orderBy: "fullName"
        },
        [TableNames.BATCH_PRINTING]: {
            page: 1,
            rowsPerPage: 25,
            order: "desc",
            orderBy: "transactionDate"
        },
        [TableNames.AUDIT_HISTORY]: {
            page: 0,
            rowsPerPage: 10,
            order: "desc",
            orderBy: "date"
        },
        [TableNames.STATUS_HISTORY]: {
            page: 0,
            rowsPerPage: 10,
            order: "desc",
            orderBy: "statusDate"
        },
        [TableNames.ADJUDICATION_DOCS]: {
            page: 0,
            rowsPerPage: 5,
            order: "desc",
            orderBy: "addedDate" //or date
        },
        [TableNames.OUTGOING_TRANSMISSION]: {
            page: 0,
            rowsPerPage: 5,
            order: "desc",
            orderBy: "date"
        },
        [TableNames.INCOMING_RESPONSE]: {
            page: 0,
            rowsPerPage: 5,
            order: "desc",
            orderBy: "date"
        },
        [TableNames.DOCUMENT_UPLOAD]: {
            page: 0,
            rowsPerPage: 10,
            order: "desc",
            orderBy: "date"
        },
        [TableNames.EMAIL_DELIVERY]: {
            page: 0,
            rowsPerPage: 10,
            order: "desc",
            orderBy: "date"
        },
    },
    headerButtonConfig: {
        handler: () => { },
        headerButtonIcon: null,
        buttonLabel: "",
        disabled: false,
        text: ""
    },
    columnStateDispatch: () => { },
    columnState: {
        page: {
            [PageNames.TRANSACTION_SUMMARY]: {
                [TableNames.TRANSACTION_SUMMARY]: {
                    columnVisibility: {
                        fullName: false,
                        firstName: true,
                        middleName: false,
                        lastName: true,
                        ueid: true,
                        stateRFPCode: true,
                        stateRFPLiteral: true,
                        status: true,
                        hitNoHit: true,
                        transactionDate: true,
                        tcn: true,
                        agency: true,
                        secondaryOri: true,
                        lastViewedDate: true,
                        ssn: true,
                        dob: false,
                        race: false,
                        gender: false,
                        actions: true,
                        rbSub: false
                    },
                    filters: [

                    ],
                },
                [TableNames.REJECT_CODES]: {
                    columnVisibility: {
                        rejectIndex: true,
                        rejectCode: true,
                        rejectDescription: true
                    },
                    filters: [

                    ],
                }
            },
            [PageNames.APPLICANT_DETAILS]: {
                [TableNames.AUDIT_HISTORY]: {
                    columnVisibility: {
                        date: true,
                        operator: true,
                        location: true,
                        action: true
                    },
                    filters: []
                },
                [TableNames.STATUS_HISTORY]: {
                    columnVisibility: {
                        status: true,
                        statusDate: true
                    },
                    filters: []
                },
                [TableNames.ADJUDICATION_DOCS]: {
                    columnVisibility: {
                        addedDate: true,
                        decision: true,
                        fileNameControl: true,
                        actions: true
                    },
                    filters: []
                },
                [TableNames.OUTGOING_TRANSMISSION]: {
                    columnVisibility: {
                        status: true,
                        agency: true,
                        date: true
                    },
                    filters: []
                },
                [TableNames.INCOMING_RESPONSE]: {
                    columnVisibility: {
                        date: true,
                        type1Field7: true,
                        type2Field59: true,
                    },
                    filters: []
                },
                [TableNames.DOCUMENT_UPLOAD]: {
                    columnVisibility: {
                        checkbox: true,
                        fileName: true,
                        userName: true,
                        date: true,
                        fileSize: true,
                        actions: true
                    },
                    filters: []
                },
                [TableNames.EMAIL_DELIVERY]: {
                    columnVisibility: {
                        checkbox: true,
                        fileName: true,
                        userName: true,
                        date: true,
                        fileSize: true,
                        actions: true
                    },
                    filters: []
                }
            },
            [PageNames.RAPBACK_MAINTENANCE]: {
                [TableNames.RAPBACK_MAINTENANCE]: {
                    columnVisibility: {
                        fullName: true,
                        dob: false, //or dateOfBirth
                        rapbackSubId: true,
                        primaryOri: true, //or primaryOri                        
                        subscriptionDate: true,
                        expirationDate: true,
                        deletionDate: true,
                        status: true,
                        actions: true,
                    },
                    filters: []
                },
                [TableNames.RB_SUB_AUDIT_HISTORY]: {
                    columnVisibility: {
                        operator: true,
                        location: true,
                        date: true,
                        action: true
                    },
                    filters: []
                }

            },
            [PageNames.RAPBACK_PRENOTIFICATIONS]: {
                [TableNames.RAPBACK_PRENOTIFICATIONS]: {
                    columnVisibility: {
                        fullName: true,
                        dob: false,
                        rapbackId: true,
                        primaryOri: true,
                        secondaryOri: true,
                        subscriptionDate: true,
                        expirationDate: true,
                        deletionDate: true,
                        status: true,
                        actions: true
                    },
                    filters: []
                }


            },
            [PageNames.RAPBACK_VALIDATIONS]: {
                [TableNames.RAPBACK_VALIDATIONS]: {
                    columnVisibility: {
                        fullName: true,
                        dob: false,
                        rapbackId: true,
                        primaryOri: true,
                        secondaryOri: true,
                        subscriptionDate: true,
                        expirationDate: true,
                        unsubscribedDate: true,
                        status: true,
                        actions: true
                    },
                    filters: [
                        {
                            filterLabel: "Time Remaining",
                            filterColumn: "timeRemaining",
                            filterIsBool: false,
                            filterIsNumber: true,
                            filterValues: {
                                11: {
                                    selected: true,
                                    label: "11 - 60 Days"
                                },
                                10: {
                                    selected: true,
                                    label: "2 - 10 Days"
                                },
                                1: {
                                    selected: true,
                                    label: "1 Day"
                                }
                            }
                        }
                    ]
                }

            },
            [PageNames.RAPBACK_SUMMARY]: {
                [TableNames.RAPBACK_SUMMARY]: {
                    columnVisibility: {
                        firstName: true,
                        middleName: false,
                        lastName: true,
                        reason: true,
                        ssn: true,
                        insertDate: true,
                        sid: true,
                        isHit: false,
                        oris: true,
                        lastViewedDate: true,
                        actions: true
                    },
                    filters: [
                        {
                            filterLabel: "Last Viewed",
                            filterColumn: "viewed",
                            filterIsBool: true,
                            filterValues: {
                                viewed: { selected: true, label: "Viewed", boolMap: true },
                                notViewed: { selected: true, label: "Not Viewed", boolMap: false }
                            }
                        }
                    ]
                },
                [TableNames.RB_SUMMARY_AUDIT_HISTORY]: {
                    columnVisibility: {
                        operator: true,
                        location: true,
                        date: true,
                        action: true
                    },
                    filters: []
                }

            },
            [PageNames.BATCH_PRINTING]: {
                [TableNames.BATCH_PRINTING]: {
                    columnVisibility: {
                        checkbox: true,
                        firstName: true,
                        lastName: true,
                        reasonFingerPrinted: true,
                        status: true,
                        transactionDate: true,
                        transactionNumber: true,
                        ori: true
                    },
                    filters: []
                }

            },
            [PageNames.AGENCY_MANAGEMENT]: {
                [TableNames.AGENCY_MANAGEMENT]: {
                    columnVisibility: {
                        ori: true,
                        secondaryOri: true,
                        reasonFingerPrinted: true,
                        agencyName: true,
                        distributionMethod: true,
                        agencyEmail: true,
                        agencyAddress: true,
                        agencyCity: true,
                        agencyState: true,
                        agencyZipcode: true
                    },
                    filters: []
                }


            },
            [PageNames.USER_MANAGEMENT]: {
                [TableNames.USER_MANAGEMENT]: {
                    columnVisibility: {
                        fullName: true,
                        loginName: true,
                        securityLevel: true,
                        status: true,
                        emailAddress: true,
                        primaryOri: true,
                        secondaryOri: true,
                        reasonFingerprinted: true,
                        actions: true
                    },
                    filters: []
                }

            }

        }
    },
    searchParams: [],
    isDelete: false,
    configFile: 'sticky-settings.json',
    configBody: {},
    isPost: false,
    simpleSearchRan: false,
    runFilters: false,
    filtersAppliedByTable: {},
    appliedFiltersByTable: {},
    setFiltersAppliedByTable: () => { },
    setAppliedFiltersByTable: () => { },
    zoomLevel: 1,
    disableButton: false,
}
